import { Component } from '@angular/core';
import { ViewController, Events } from 'ionic-angular';
import { NavParams } from 'ionic-angular/navigation/nav-params';
import moment from 'moment';
import { TimeoutFunctionsProvider } from '../../providers/timeout-functions/timeout-functions';
import { SoundsProvider } from '../../providers/sounds/sounds';
/**
 * Generated class for the CoDateTimePickerPopoverComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-date-time-picker-popover',
  templateUrl: 'co-date-time-picker-popover.html'
})
export class CoDateTimePickerPopoverComponent {
  rawTime: any;
  rawDate: any;
  time: {hour: string, minute: string, period: string};
  text: string;
  screen: string;
  rangePoint: string;
  date: {month: string, day: string, year: string};
  constructor(public viewCtrl: ViewController, public navParams: NavParams, private events: Events, private timeout: TimeoutFunctionsProvider, private sounds : SoundsProvider) {
    this.events.subscribe('timeoutCalled', () => this.timeout.doLogoutFunctions(this));
    this.screen = this.navParams.data.screen;
    this.rangePoint = this.navParams.data.rangePoint;
    this.time = {hour: '12', minute: '00', period: 'am'};
    this.date = {month: moment().format('MMM'), day: moment().format('D'), year: moment().format('YYYY') }
    this.rawTime = moment().hour(0).minute(0);
    this.rawDate = moment().startOf('day');
    if(this.navParams.data.currentFilters && this.screen === 'time'){
      let time = this.navParams.data.currentFilters;
      this.rawTime = moment().hour(time[this.rangePoint].hour).minute(time[this.rangePoint].minute);
      this.time = {hour: this.rawTime.format('h'), minute: this.rawTime.format('mm'), period: this.rawTime.format('a')};
      //add to time
    }
    if (this.navParams.data.currentFilters && this.screen === 'date'){

    }
  }

  ngAfterViewInit(): void {
    this.sounds.playSoundOnButtonClick();
  }

  changePeriod(){
    this.time.period === 'am'? this.time.period = 'pm' : this.time.period = 'am';
  }

  changeTime(digit, direction){
    direction === 'up'? this.rawTime.add(1, digit) : this.rawTime.subtract(1, digit);
    this.time.hour = this.rawTime.format('h');
    this.time.minute = this.rawTime.format('mm');
    this.time.period = this.rawTime.format('a');
  }

  changeDate(digit, direction){
    // console.log(digit,direction,this.rawDate);
    direction === 'up'? this.rawDate.add(1, digit) : this.rawDate.subtract(1, digit);
    this.date = {month: this.rawDate.format('MMM'), day: this.rawDate.format('D'), year: this.rawDate.format('YYYY') }
  }

}



// WEBPACK FOOTER //
// ./src/components/co-date-time-picker-popover/co-date-time-picker-popover.ts